<div
  class="flex gap-6 rounded-2xl bg-neutral-100 p-6 max-xl:flex-wrap xl:h-(--fill-viewport-height)"
  membersFillViewportHeight
>
  <!-- Extended profile block -->
  <div class="flex w-full flex-col gap-4 rounded-2xl bg-neutral-50 p-6 xl:w-1/2 xl:overflow-y-auto">
    <div class="flex justify-between">
      <!-- Full name -->
      <h4>
        <ng-container *ngTemplateOutlet="childEmoji; context: { birthDate: memberProfile().birthDate }"></ng-container>
        {{ memberProfile().fullName }}
      </h4>
      <!-- Chat button -->
      @if (config().showChatButton) {
        <div>
          <button
            class="flex items-center justify-center rounded-full border-2 border-primary-500 bg-primary-500 p-2 text-neutral-0"
            (click)="redirectToClientsChat(memberProfile().userId)"
          >
            <mat-icon>chat</mat-icon>
          </button>
        </div>
      }
    </div>
    <div class="xl:flex xl:flex-col">
      <!-- Additional profiles -->
      @if (memberProfile().delegatedProfiles?.length > 0) {
        <div class="xl:flex">
          <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">{{ "profile.label.additionalProfiles" | translate }}</p>

          <div class="flex flex-col items-start border-neutral-0 pb-2.5 xl:flex-1 xl:gap-y-2 xl:border-t xl:py-2.5">
            @for (delegatedProfile of memberProfile().delegatedProfiles; track delegatedProfile.id) {
              <a
                class="truncate text-primary-500 hover:cursor-pointer hover:text-primary-600"
                [routerLink]="['/members/' + delegatedProfile.id]"
              >
                {{ delegatedProfile.fullName }} ({{ calculateAge(delegatedProfile.birthDate) }} р.)
                <ng-container *ngTemplateOutlet="childEmoji; context: { birthDate: delegatedProfile.birthDate }"></ng-container>
              </a>
            }
          </div>
        </div>
      }
      <!-- Contracts -->
      <div class="xl:flex">
        <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">{{ "profile.label.contracts" | translate }}</p>
        <div class="border-neutral-100 pb-2.5 xl:flex-1 xl:truncate xl:border-t xl:py-2.5">
          <shared-contract-item
            [type]="'list-items'"
            [contracts]="memberProfile().contracts"
          ></shared-contract-item>
        </div>
      </div>
      <!-- Phone number -->
      @if (memberProfile().phoneNumber) {
        <div class="xl:flex">
          <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">{{ "profile.label.phoneNumber" | translate }}</p>
          <p class="border-neutral-100 pb-2.5 xl:flex-1 xl:truncate xl:border-t xl:py-2.5">{{ memberProfile().phoneNumber }}</p>
        </div>
      }
      <!-- Email -->
      @if (memberProfile().email) {
        <div class="xl:flex">
          <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">{{ "profile.label.email" | translate }}</p>
          <p class="border-neutral-100 pb-2.5 xl:flex-1 xl:truncate xl:border-t xl:py-2.5">{{ memberProfile().email }}</p>
        </div>
      }
      <!-- Birth date -->
      @if (memberProfile().birthDate) {
        <div class="xl:flex">
          <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">{{ "profile.label.birthDate" | translate }}</p>
          <p class="border-neutral-100 pb-2.5 xl:flex-1 xl:truncate xl:border-t xl:py-2.5">{{ formatDateFunction(memberProfile().birthDate) }}</p>
        </div>
      }
      <!-- Actual address -->
      @if (memberProfile().actualAddress) {
        <div class="xl:flex">
          <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">{{ "profile.label.actualAddress" | translate }}</p>
          <p class="border-neutral-100 pb-2.5 xl:flex-1 xl:truncate xl:border-t xl:py-2.5">{{ memberProfile().actualAddress }}</p>
        </div>
      }
      <!-- Doctor name -->
      <div class="xl:flex">
        <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">{{ "profile.label.doctor" | translate }}</p>
        <div class="flex items-center gap-2 border-neutral-100 pb-2.5 xl:flex-1 xl:border-t xl:py-2.5">
          <div class="min-w-0 flex-1">
            @if (memberProfile().doctorId && memberProfile().doctorName) {
              <span class="truncate">{{ memberProfile().doctorName }}</span>
            } @else {
              <shared-warning-message
                [size]="'small'"
                [text]="'profile.values.doctor.empty' | translate"
              ></shared-warning-message>
            }
          </div>
          @if (config().showDoctorEdit) {
            <button
              class="btn flex shrink-0 items-center justify-center rounded-full bg-neutral-100 p-1 text-neutral-300 underline hover:bg-neutral-200 hover:text-neutral-500"
              [type]="'button'"
              (click)="openChangeDoctorDialog()"
            >
              <mat-icon [matTooltip]="(!!memberProfile().doctorId ? 'buttons.edit' : 'buttons.add') | translate">
                {{ !!memberProfile().doctorId ? "edit" : "add" }}
              </mat-icon>
            </button>
          }
        </div>
      </div>
      <!-- External Patient References -->
      @for (externalRef of externalRefs(); track externalRef.partnerId) {
        @if ($first || showAllExternalRefs()) {
          <div class="xl:flex">
            <p class="border-t border-neutral-100 pt-2.5 text-neutral-300 xl:w-[120px] xl:shrink-0 xl:py-2.5 xl:pr-6">
              @if (externalRef.partnerId === liloPartnerId) {
                {{ "profile.label.helsiId" | translate }}
              } @else {
                {{ externalRef.partnerName }}
              }
            </p>
            <div class="flex items-center gap-2 border-neutral-100 pb-2.5 xl:flex-1 xl:border-t xl:py-2.5">
              <div class="min-w-0 flex-1 xl:truncate">
                @if (externalRef.patientId) {
                  {{ externalRef.patientId }}
                } @else {
                  <shared-warning-message
                    [size]="'small'"
                    [text]="'warning.client.patientId' | translate"
                  ></shared-warning-message>
                }
              </div>
              @if (externalRef.partnerId === liloPartnerId && config().showPartnerIdEdit) {
                <button
                  class="btn flex shrink-0 items-center justify-center rounded-full bg-neutral-100 p-1 text-neutral-300 underline hover:bg-neutral-200 hover:text-neutral-500"
                  [type]="'button'"
                  (click)="openHelsiPatientIdDialog()"
                >
                  <mat-icon [matTooltip]="(!!externalRef.patientId ? 'buttons.edit' : 'buttons.add') | translate">
                    {{ !!externalRef.patientId ? "edit" : "add" }}
                  </mat-icon>
                </button>
              }
              @if ($first) {
                <button
                  class="btn flex shrink-0 items-center justify-center rounded-full bg-neutral-100 p-1 text-neutral-300 underline hover:bg-neutral-200 hover:text-neutral-500"
                  [type]="'button'"
                  (click)="toggleExternalRefsView()"
                >
                  <mat-icon>{{ showAllExternalRefs() ? "expand_less" : "expand_more" }}</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
  @if (config().showPackageCoverage) {
    <!-- Package coverage block -->
    <div class="flex w-full min-w-0 flex-col gap-4 rounded-2xl bg-neutral-50 p-6 xl:min-h-0 xl:w-1/2">
      @if (coverage(); as coverage) {
        <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
          <div class="flex items-center gap-1">
            <h4>{{ coverage.packageCore.name }}</h4>
            @if (coverage.packageCore.internalName) {
              <mat-icon
                class="text-neutral-400"
                [matTooltip]="coverage.packageCore.internalName"
                >info_outline</mat-icon
              >
            }
          </div>
          <span class="text-sm text-neutral-400">{{ ("packageConfigurator.label.activeFrom" | translate) + " " + formatDateFunction(coverage.activeFrom) }}</span>
        </div>
      }
      <members-package-coverage
        [userId]="memberProfile().userId"
        [fillHeight]="true"
      ></members-package-coverage>
    </div>
  } @else {
    <!-- Empty block for the purpose of POC -->
    <div class="flex w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-neutral-300 p-6 xl:w-1/2">
      <img
        priority="true"
        alt="Product logo"
        width="43"
        height="32"
        [ngSrc]="'/assets/images/logo.svg'"
      />
    </div>
  }
</div>

<ng-template
  #childEmoji
  let-birthDate="birthDate"
>
  @if (calculateAge(birthDate) < 18) {
    🐣
  }
</ng-template>
